import React, { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  imagesend,
  pdficon,
  pdficon3,
  plusicon,
  refreshicon,
  pdficon5,
} from "../imagepath";
// import { onShowSizeChange, itemRender } from "../Pagination";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import useDebounce from "../../utils/hooks";

import {
  generateCsv,
  handleDownloadPdfHolidays,
  handleDownloadPdfAiSummary,
  handleShowJson,
} from "../../utils/constant/constant";
import { toast } from "react-toastify";
import { getHolidays } from "../../connections/getHolidays";
import { deleteHolidays } from "../../connections/deleteHolidays";
import { getAiSummaryList } from "../../connections/getAiSummaryList";
import { render } from "@testing-library/react";
import { deleteAiSummary } from "../../connections/deleteAiSummary";

const SUMMARY_TYPE_OPTIONS = [
  "test_reports",
  "audio_prompt",
  "prescription_disclaimer",
  "diagnosis",
  "medicine",
  "purchase_order",
  "medical_test",
  "appointment",
  "consultation_summary",
  "octabot",
  "intelligence_summary",
  "drug_interaction",
].map((v) => ({
  label: v.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()),
  value: v,
}));

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "#007A99" : "rgba(46,55,164,0.1)",
    boxShadow: state.isFocused ? "0 0 0 1px #007A99" : "none",
    "&:hover": { borderColor: "rgba(46,55,164,0.1)" },
    borderRadius: "10px",
    fontSize: "14px",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
    transition: "250ms",
    width: "35px",
    height: "38px",
  }),
};

const AISummaryList = () => {
  const [deleteId, setDeleteId] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(60);
  const [filter, setFilter] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [patientIdInput, setPatientIdInput] = useState("");
  const [resourceIdInput, setResourceIdInput] = useState("");
  const [resourceTypeInput, setResourceTypeInput] = useState("");

  const debouncedPatientId = useDebounce(patientIdInput, 1000);
  const debouncedResourceId = useDebounce(resourceIdInput, 1000);
  const debouncedResourceType = useDebounce(resourceTypeInput, 1000);

  const {
    user: { user },
  } = useSelector((store) => store);
  const navigate = useNavigate();
  const {
    data: getAiSummaryListData,
    isLoading: isSummaryLoading,
    refetch: refetchAiSummary,
  } = useQuery({
    queryKey: ["getAiSummaryList", page, pageSize, filter],
    queryFn: () => getAiSummaryList(user?.token, page, pageSize, filter),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleFilterChange = (key, value) => {
    setFilter((prev) => {
      const next = { ...prev };
      if (value === null || value === "" || value === undefined) {
        delete next[key];
      } else {
        next[key] = value;
      }
      return next;
    });
  };

  useEffect(() => {
    handleFilterChange("patient_id", debouncedPatientId);
  }, [debouncedPatientId]);

  useEffect(() => {
    handleFilterChange("resource_id", debouncedResourceId);
  }, [debouncedResourceId]);

  useEffect(() => {
    handleFilterChange("resource_type", debouncedResourceType);
  }, [debouncedResourceType]);

  useEffect(() => {
    if (!showFilter) {
      setFilter({});
      setPatientIdInput("");
      setResourceIdInput("");
      setResourceTypeInput("");
    }
  }, [showFilter]);

  const handleResetFilter = () => {
    setFilter({});
    setPatientIdInput("");
    setResourceIdInput("");
    setResourceTypeInput("");
  };

  const wrapCell = { style: { whiteSpace: "normal", wordBreak: "break-word" } };
  const noWrapHeader = { style: { whiteSpace: "nowrap" } };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      width: 60,
      onHeaderCell: () => noWrapHeader,
    },
    {
      title: "Patient",
      width: 150,
      onHeaderCell: () => noWrapHeader,
      onCell: () => wrapCell,
      render: (_, record) => (
        <Link
          to={`/admin/patient/${record?.patient?.id || record?.patient_id}`}
          style={{ textDecoration: "underline" }}
        >
          {record?.patient_name || record?.patient?.id || record?.patient_id}
        </Link>
      ),
    },
    {
      title: "Resource Id",
      width: 110,
      onHeaderCell: () => noWrapHeader,
      render: (_, record) => record?.resource_id ?? "NA",
    },
    {
      title: "Resource Type",
      width: 130,
      onHeaderCell: () => noWrapHeader,
      onCell: () => wrapCell,
      render: (_, record) => record?.resource_type ?? "NA",
    },
    {
      title: "Summary Type",
      width: 130,
      onHeaderCell: () => noWrapHeader,
      onCell: () => wrapCell,
      render: (_, record) => record?.summary_type ?? "NA",
    },
    {
      title: "Chief Complaints",
      onHeaderCell: () => noWrapHeader,
      onCell: () => wrapCell,
      render: (_, record) => record?.summary_json?.chiefComplaints ?? "NA",
    },
    {
      title: "Red Flags",
      onHeaderCell: () => noWrapHeader,
      onCell: () => wrapCell,
      render: (_, record) => {
        const flags = record?.summary_json?.redFlagsDetected;
        if (!flags?.length) return "NA";
        return (
          <Tag color="default" style={{ margin: 0 }}>
            {flags?.length} Flags
          </Tag>
        );
      },
    },
    {
      title: "",
      dataIndex: "FIELD8",
      render: (_, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  className="dropdown-item"
                  to={`/admin/ai_summary/${record?.id}`}
                >
                  <i className="fa-regular fa-eye m-r-5" />
                  View
                </Link>
                {/* <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate("/admin/update-holidays", { state: record })
                  }
                
                >
                  <i className="far fa-edit me-2" />
                  Edit
                </button> */}
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_patient"
                  onClick={() => {
                    setDeleteId(record?.id);
                  }}
                >
                  <i className="fa fa-trash-alt m-r-5"></i> Delete
                </Link>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  const deleteHolidaysFun = async () => {
    try {
      const data = await deleteAiSummary(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Ai Summary Deleted Successfully", deleteId);
        refetchAiSummary();
        setDeleteId(null);
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
    // refetchAiSummary();
  };

  return (
    <>
      <Header />
      <Sidebar activeClassName="ai_summary" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Ai Summary</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Ai Summary List</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* Table Header */}
                    <div className="page-table-header mb-2">
                      {/* Filter Panel */}
                      {showFilter && (
                        
                        <div className="col filter-container ">
                          <div className="doctor-table-blk">
                            <h3 style={{ marginBottom: 2 }}>Filter</h3>
                          </div>
                          <div className="row mt-2  p-2">
                            <div className="col-12 col-md-4 col-lg-2">
                              <div className="form-group local-forms">
                                <label>Patient Id</label>
                                <input
                                  value={patientIdInput}
                                  onChange={(e) =>
                                    setPatientIdInput(e.target.value)
                                  }
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter patient id"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-2">
                              <div className="form-group local-forms">
                                <label>Resource Id</label>
                                <input
                                  value={resourceIdInput}
                                  onChange={(e) =>
                                    setResourceIdInput(e.target.value)
                                  }
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter resource id"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-2">
                              <div className="form-group local-forms">
                                <label>Resource Type</label>
                                <input
                                  value={resourceTypeInput}
                                  onChange={(e) =>
                                    setResourceTypeInput(e.target.value)
                                  }
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter resource type"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-2">
                              <div className="form-group local-forms">
                                <label>Summary Type</label>
                                <Select
                                  isClearable
                                  placeholder="Select type"
                                  options={SUMMARY_TYPE_OPTIONS}
                                  value={
                                    SUMMARY_TYPE_OPTIONS.find(
                                      (o) => o.value === filter.summary_type,
                                    ) || null
                                  }
                                  onChange={(e) =>
                                    handleFilterChange(
                                      "summary_type",
                                      e ? e.value : null,
                                    )
                                  }
                                  menuPortalTarget={document.body}
                                  styles={selectStyles}
                                  components={{
                                    IndicatorSeparator: () => null,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-2 mb-2">
                              <button
                                onClick={handleResetFilter}
                                className="btn p-2"
                                style={{
                                  border: "1px solid #007A99",
                                  color: "#007A99",
                                  borderRadius: 8,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Ai Summary List</h3>
                            <div className="doctor-search-blk">
                              <div className="add-group">
                                <Link
                                  id="refetch-btn"
                                  onClick={refetchAiSummary}
                                  className="btn btn-primary doctor-refresh ms-2"
                                >
                                  <img src={refreshicon} alt="#" />
                                </Link>
                                <Link
                                  onClick={() => setShowFilter((p) => !p)}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <FilterAltIcon
                                    sx={{
                                      color: "#0097B2",
                                      ":hover": {
                                        color: "white",
                                      },
                                    }}
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-auto text-end float-end ms-auto download-grp">
                          {/* <Link id="download-pdf" to="#" className=" me-2"> */}
                          <img
                            className=" me-2"
                            onClick={() =>
                              handleDownloadPdfAiSummary(
                                getAiSummaryListData?.payload?.ai_summaries,
                              )
                            }
                            src={pdficon}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                          {/* <Link
                           
                            id="download-csv"
                            className=" me-2"
                          > */}
                          <img
                            onClick={() =>
                              generateCsv(
                                getAiSummaryListData?.payload?.ai_summaries,
                              )
                            }
                            className=" me-2"
                            src={pdficon3}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              handleShowJson(
                                getAiSummaryListData?.payload?.ai_summaries,
                              )
                            }
                            width={"25px"}
                            height={"26px"}
                            src={pdficon5}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* /Filter Panel */}
                    <div className="table-responsive doctor-list">
                      <Table
                        loading={isSummaryLoading}
                        pagination={{
                          current: page,
                          pageSize: pageSize,
                          total: getAiSummaryListData?.meta?.total_count,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: handlePageChange,
                        }}
                        columns={columns}
                        //  scroll={{ x: "max-content" }}
                        dataSource={getAiSummaryListData?.payload?.ai_summaries}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={deleteHolidaysFun}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      ;
    </>
  );
};

export default AISummaryList;
